/**
 * Office WebViews often lack ES2020 `Promise.allSettled`. Some builds may still emit calls to it.
 * This assigns a spec-compatible implementation on `Promise` before any other app code runs.
 */
type SettledResult<T> =
  | { status: "fulfilled"; value: T }
  | { status: "rejected"; reason: unknown };

function allSettledPolyfill<T>(iterable: Array<Promise<T> | T>): Promise<Array<SettledResult<T>>> {
  const promises = Array.from(iterable).map((p) => Promise.resolve(p));
  return Promise.all(
    promises.map((p) =>
      p.then(
        (value): SettledResult<T> => ({ status: "fulfilled", value }),
        (reason): SettledResult<T> => ({ status: "rejected", reason })
      )
    )
  );
}

if (typeof Promise !== "undefined" && typeof (Promise as unknown as { allSettled?: unknown }).allSettled !== "function") {
  (Promise as unknown as { allSettled: typeof allSettledPolyfill }).allSettled = allSettledPolyfill;
}
